<template>
  <div class="all">
    <div class="top-page">
      <router-link to="../" class="button">←　ヘルプページトップへ戻る</router-link>
    </div>
    <div class="tab_box">
      <ul class="tab_list">
        <li v-bind:class="{active:isTabActive == 1}" @click="changeActive(1)">新規作成</li>
        <li v-bind:class="{active:isTabActive == 2}" @click="changeActive(2)">　編集　</li>
      </ul>
      <ul class="article">
        <li v-if="isTabActive == 1">
          <div style="border:1px solid black; background-color:floralwhite;"><br><br>
            <div style="padding:0px 10%;">
              <table class="new-table">
                <tr>
                  <th>タイトル</th>
                  <td style="min-width: 500px;">
                    <b-input v-model="inputs.item" maxlength="20" placeholder="タイトルを入力（20字以内）"></b-input>
                  </td>
                </tr>
                <tr>
                  <th>説明</th>
                  <td style="min-width: 500px;">
                    <b-input v-model="inputs.description" maxlength="30" placeholder="説明を入力（30字以内）"></b-input>
                  </td>
                </tr>
                <tr>
                  <th>画像<br><br>
                    <a class="button" @click="isFileUp=true;">
                      <b-icon icon="upload"></b-icon>
                      <span>アップロード</span>
                    </a>
                  </th>
                  <td height="200">
                    <img
                      :src="inputs.image"
                      style="width: 150px; height: 150px; border: 1px solid gray;"
                    >
                  </td>
                </tr>
              </table><br><br><br>
              <button class="button is-primary is-fullwidth" @click="clickCreateHelpItem()">作成する</button>
            </div><br><br>
          </div>
        </li>
        <li v-if="isTabActive == 2">
          <div style="border:1px solid black; background-color:floralwhite;">
            <div style="padding-top: 10px; overflow: scroll !important">
              <div style="margin:0px 10%;">
                <div v-if="isDanger==true" class="box-text-notice">順番で重複している箇所があります。</div>
                <table class="edit-table">
    　            <tr>
    　              <th v-for="(t, i) in tableHeader" :key="i">{{t}}</th>
    　            </tr>
        　        <tr v-for="(a, index) in sortedHelpItemsBySort" :key="index">
                    <td style="min-width: 70px;">
                      <button v-bind:disabled="isEditId != '' && isEditId != a.item_id" class="button is-small is-primary" v-if="isEditId != a.item_id" @click="editButton(a)">編集</button>
                      <button class="button is-small is-primary" v-else @click="updateButton(a.sort_id)">更新</button>
                    </td>
                    <td style="min-width: 300px; text-align: left;" v-if="isEditId != a.item_id">{{a.item}}</td>
                    <td style="min-width: 300px; text-align: left;" v-else><b-input size="is-small" type="text" class="form-control"  maxlength="20" v-model="isItem"></b-input></td>
                    <td style="min-width: 350px; text-align: left;" v-if="isEditId != a.item_id">{{a.description}}</td>
                    <td style="min-width: 350px; text-align: left;" v-else><b-input size="is-small" type="text" class="form-control"  maxlength="30" v-model="isDescription"></b-input></td>
                    <td style="min-width: 90px; text-align: left;　background-color:red; color:white;" v-if="isEditId != a.item_id && getDuplication(a.sort_id) == true">{{a.sort_id}}</td>
                    <td style="min-width: 90px; text-align: left;　" v-else-if="isEditId != a.item_id">{{a.sort_id}}</td>
                    <td style="min-width: 90px; text-align: left;" v-else><b-input style="width:50px;" size="is-small" type="number" min="1" class="form-control"  v-model="isSort"></b-input></td>
                    <td style="min-width: 120px; text-align: left;" v-if="isEditId != a.item_id"><img :src="a.image" v-if="a.image!=''" style="height:30px;width:30px;object-fit: cover;"></td>
                    <td style="min-width: 120px; text-align: left;" v-else>
                      <img :src="a.image" v-if="inputs.image==''" style="height:30px;width:30px;object-fit: cover;">
                      <img :src="inputs.image" v-else style="height:30px;width:30px;">
                      <a class="button" @click="isFileUp=true;">
                        <b-icon icon="upload"></b-icon>
                      </a>
                    </td>
                    <td style="min-width: 100px;">
                      <button v-bind:disabled="isEditId != '' && isEditId != a.item_id" class="button is-small is-danger" v-if="isEditId != a.item_id" @click="deleteButton(a.item_id, a.sort_id)">削除</button>
                      <button class="button is-small is-danger" v-else @click="cancelEdit()">編集中止</button></td>
    　            </tr>
                </table><br><br>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
    <!-- 以下、モーダル -->
    <!-- 作成 -->
    <b-modal :active.sync="isCreate" @close="isCreate=false">
      <div class="card" style="border-radius: 5px;  width:500px; display:inline-block;">
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              作成しました。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="successCreate()">OK</a>
        </footer>
      </div>
    </b-modal>
    <!-- 削除 -->
    <b-modal :active.sync="isDelete" @close="isDelete=false">
      <div class="card" style="border-radius: 5px; width:600px; display:inline-block;" v-if="getConfirmation">
        <div class="card-content">
          <p>
            <b-message v-if="this.categoryBox.length>0" type="is-danger" has-icon>
              この項目を削除すると以下の質問も削除されます。<br>
              本当に削除してもよろしいですか。
              <ul v-for="(a, index) in categoryBox" :key="index">
                <li>● {{a}}</li>
              </ul>
            </b-message>
            <b-message v-else type="is-danger" has-icon>
              本当に削除してもよろしいですか。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="noDelete()">いいえ</a>
          <a class="card-footer-item" @click="deleteText(nowID)">はい</a>
        </footer>
      </div>
      <div class="card" style="border-radius: 5px;  width:500px; display:inline-block;" v-if="!getConfirmation">
        <div class="card-content">
          <p>
            <b-message type="is-info" has-icon>
              削除しました。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="successDelete()">OK</a>
        </footer>
      </div>
    </b-modal>
    <!-- 画像トリミング -->
    <b-modal :active.sync="isFileUp" @close="isFileUp=false">
      <Cropper @imageMethod="imageMessage"></Cropper>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cropper from "@/views/DashBoard/ChatBot/Cropperjsicon"

export default {
  name: "HelpInputBody",
  components:{
    Cropper
  },
  computed: {
    ...mapState("help", ["helpItems", "helps"]),
    ...mapState("auth", ["user"]),
    sortedHelpItemsBySort() {
      console.debug('*** Start *** sortedHelpItemsBySort')
      return this.helpItems.sort((a, b) => {
        return a.sort_id < b.sort_id ? -1 : a.sort_id > b.sort_id ? 1 : 0;
      });
    }
  },
  data() {
    return {
      inputs: {
        image:""
      },
      tableHeader:["", "タイトル", "説明", "順番", "画像", ""],
      isTabActive:1, //タブ切り替え 1：新規作成 2：編集
      isEditId: "",
      isDeleteId:"",
      isItem:"",
      isDescription:"",
      isSort:"",
      isImage:"",
      isDelete: false,
      setBox:[],
      categoryBox:[],
      isFileUp: false,
      getConfirmation:true,
      isCreate:false,
      isDanger:false,
      SortBox:[],
      DuplicationSort:[],
    };
  },
  mounted() {
    console.debug('*** Start *** mounted')
    this.$store.dispatch("help/getHelpItem");
    this.$store.dispatch("help/getHelp");
    var sort_number = 0
    this.SortBox=[]
    this.DuplicationSort=[]
    setTimeout(() => {
      for (var i in this.helps){
       this.setBox.push(this.helps[i].item_id)
      }
      for(var i in this.helpItems){
        this.SortBox.push(this.helpItems[i].sort_id)
      this.DuplicationSort = this.SortBox.filter(function (x, i, self) {
            return self.indexOf(x) === i && i !== self.lastIndexOf(x);
        });
      if(this.DuplicationSort.length > 0){
        this.isDanger = true
      }
      }
    }, 1000)
    console.debug('*** End *** mounted')
  },
  methods: {
    // タブ切り替え
    changeActive(number){
      this.isTabActive = number
      this.inputs.image = ""
    },
    getText(){
      this.SortBox=[]
      var sort_number = 0
      this.$store.dispatch("help/getHelpItem");
      setTimeout(() => {
        for(var i in this.helpItems){
          this.SortBox.push(this.helpItems[i].sort_id)
          this.DuplicationSort = this.SortBox.filter(function (x, i, self) {
            return self.indexOf(x) === i && i !== self.lastIndexOf(x);
          });
        }
        if(this.DuplicationSort.length > 0){
          this.isDanger = true
        }
      }, 1000)
    },
    // 新規作成
    clickCreateHelpItem() {
      console.debug('*** Start *** clickCreateHelpItem')
      this.inputs.sort_id = this.helpItems.length
      this.$store.dispatch("help/createHelpItem", { data: this.inputs });
      this.isCreate=true
      console.debug('*** End *** clickCreateHelpItem')
    },
    // 編集ボタン
    editButton(a){
      this.isEditId = a.item_id;
      this.isItem=a.item;
      this.isDescription=a.description;
      this.isSort=a.sort_id;
      this.isImage=a.image;
    },
    // 更新ボタン
    updateButton(nowID){
      if (this.inputs.image != ""){
        this.$store.dispatch("help/updateHelpItemImage", 
        { 
          'item_id':this.isEditId,
          'item':this.isItem,
          'description':this.isDescription,
          'sort_id':this.isSort,
          'image':this.inputs.image
          }
        )
      } else{
      this.$store.dispatch("help/updateHelpItem", 
        { 
          'item_id':this.isEditId,
          'item':this.isItem,
          'description':this.isDescription,
          'sort_id':this.isSort,
        }
      )}
      setTimeout(() => {
        this.getText()
      }, 1000)
      this.isEditId = ""
    },
    // 編集中止
    cancelEdit(){
      this.isEditId = ""
      this.isSort = ""
    },
    // トリミング
    imageMessage(photo) {
      console.debug('*** Start *** imageMessage')
      this.inputs.image = photo;
      console.debug('*** End *** imageMessage')
    },
    // 削除ボタン
    deleteButton(id, sort){
      this.isSort = sort
      this.isDelete=true
      this.isDeleteId= id
      for (var i in this.helps){
        if (this.helps[i].item_id == id){
          this.categoryBox.push(this.helps[i].question)
        }
      }
    },
    // 削除しますか→はい
    deleteText(){
      this.$store.dispatch('help/deleteHelpItem',
        {
          'item_id': this.isDeleteId
        }
      )
      for (var i in this.helps){
        if (this.helps[i].item_id == this.isDeleteId){
          this.$store.dispatch("help/deleteHelp",
            {
              'help_id':this.helps[i].help_id,
            })
          }
        }
      for (var i in this.helpItems){
        if (this.helpItems[i].sort_id > this.isSort){
          this.$store.dispatch("help/updateHelpItem",
            {
              'item_id':this.helpItems[i].item_id,
              'sort_id':String(Number(this.helpItems[i].sort_id) - 1)
            })
          }
        }
      setTimeout(() => {
        this.getText()
      }, 1000)
      this.isDeleteId=""
      this.getConfirmation = false
    },
    // 削除しますか→いいえ
    noDelete(){
      console.debug('*** Start *** deleteChatBot')
      this.categoryBox=[]
      this.isDelete=false
      this.isDeleteId=""
      this.isSort=""
      this.getConfirmation = true
      console.debug('*** End *** deleteChatBot')
    },
    // 作成しました
    successCreate(){
      this.isCreate=false
      this.inputs.item = ""
      this.inputs.description = ""
      this.inputs.image=""
    },
    // 削除しました
    successDelete(){
      this.isSort = ""
      this.isDeleteId = ""
      this.isDelete=false
    },
    // 重複取得
    getDuplication(id){
      for(var i in this.DuplicationSort){
        if(this.DuplicationSort[i] == id){
          return true
        }
      }
    }
  },
};
</script>

<style scoped>
/* タブ */
.tab_box{
  padding-top:50px;
}
.tab_list {    
  overflow: hidden;
  margin-left: 10%;
}
.tab_list li {    
  float: left;
  padding: 10px 0;
  width:300px;
  border: 1px solid #ccc;
  border-bottom:none;
  cursor: pointer;
  transition: .3s;
  border-radius: 15px 15px 0px 0px / 15px 15px 0px 0px;
} 
.tab_list li.active {
  border-color: #000;
  background-color: floralwhite;
  color: #000;
  cursor: auto;
}

/* 中身 */
.article{
  overflow: hidden;
  margin-top: -1px;
  margin-bottom:50px;
}
.article li {
  width: 90%;
  margin:0px auto;
  padding: auto;
  border: 1px solid #ccc;
}

/* 編集用テーブル */
.edit-table {
  width:80%;
  margin:50px auto;
}
.edit-table th,.edit-table td {
  padding: 15px;
}
.edit-table tr:nth-child(odd) {
  background: #E7EBE9;
}
.edit-table tr:nth-child(even) {
  background: #F8F8F8;
}
.edit-table tr:first-child {
  background: lightpink;
}
.edit-table th {
  text-align:center;
  color: #fff;
  border-bottom: solid 1px pink;
  border-right: solid 1px pink;
}
.edit-table td {
  color: #4A6458;
  border-bottom: solid 1px pink;
  border-right: solid 1px pink;
}

/* 新規用テーブル */
.new-table{
  width:100%;
  border-collapse: collapse;
}
.new-table tr{
  border-bottom: solid 2px white;
}
.new-table tr:last-child{
  border-bottom: none;
}
.new-table th{
  position: relative;
  text-align: left;
  background-color: lightpink;
  color: white;
  text-align: center;
  vertical-align: middle;
  padding: 10px 0;
}
.new-table th:after{
  display: block;
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  top:calc(50% - 10px);
  right:-10px;
  border-left: 10px solid lightpink;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}
.new-table td{
  text-align: center;
  background-color: #eee;
  padding: 20px;
}

/* 上部ボタン */
.top-page{
  float:left;
  margin-left:5%;
}

/* すべて */
.all{
  margin-top:40px;
}

/*警告囲み枠*/
.box-text-notice {
  position: relative;
  border: 3px double #da4033;
  border-radius: 5px;
  margin: 40px 0;
  padding: 20px 20px 5px 20px;
  font-size: 20px;
}
.box-text-notice::before {
  content: "重要！";
  position: absolute;
  background-color: floralwhite;
  color: #da4033;
  font-weight: bold;
  left: 20px;
  top: -33px;
  padding: 10px;
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/Help/HelpInputBody.vue